module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 40
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-plus",
      "size": "mini"
    },
    on: {
      "click": _vm.handleNew
    }
  }, [_vm._v("新增品牌")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "品牌名称",
      "size": "mini"
    },
    on: {
      "change": _vm.brandSearch
    },
    model: {
      value: (_vm.params.attribute_name),
      callback: function($$v) {
        _vm.$set(_vm.params, "attribute_name", $$v)
      },
      expression: "params.attribute_name"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.brandSearch
    },
    slot: "append"
  })], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.list,
      "height": _vm.wheight - 170,
      "element-loading-text": "数据加载中",
      "default-sort": {
        prop: 'bind_date',
        order: 'descending'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleDelete(scope)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "品牌图片",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.image_url) ? _c('img', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "src": scope.row.image_url
          }
        }) : _c('img', {
          attrs: {
            "src": "https://fakeimg.pl/50x50/EFEFEF/CCC/?text=brand&font=lobster"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "attribute_name",
      "label": "品牌名称"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.attribute_id) ? _c('div', [_c('el-input', {
          attrs: {
            "placeholder": "请输入品牌名称"
          },
          model: {
            value: (scope.row.attribute_name),
            callback: function($$v) {
              _vm.$set(scope.row, "attribute_name", $$v)
            },
            expression: "scope.row.attribute_name"
          }
        })], 1) : _c('div', [_vm._v(_vm._s(scope.row.attribute_name))])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-padded content-center"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "total, sizes, prev, pager, next",
      "current-page": _vm.params.page,
      "page-sizes": [10, 20, 50],
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.imgDialog,
      "sc-status": _vm.isGetImage
    },
    on: {
      "chooseImg": _vm.pickImg,
      "closeImgDialog": _vm.closeImgDialog
    }
  }), _vm._v(" "), _c('sideBar', {
    attrs: {
      "visible": _vm.show_sideBar,
      "title": '新增品牌'
    },
    on: {
      "update:visible": function($event) {
        _vm.show_sideBar = $event
      }
    }
  }, [_c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "品牌名"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.attribute_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "attribute_name", $$v)
      },
      expression: "form.attribute_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "品牌logo"
    }
  }, [_c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("只能上传jpg/png文件，且不超过2M （建议尺寸：200px * 200px）")]), _vm._v(" "), _c('div', {
    staticClass: "upload-box",
    on: {
      "click": _vm.handleImgPicker
    }
  }, [(_vm.form.image_url) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.form.image_url
    }
  }) : _c('i', {
    staticClass: "iconfont icon-camera avatar-uploader-icon"
  })])]), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3a068ae0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a068ae0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/goods/attributes/brand.vue
// module id = 2628
// module chunks = 0